import React, { useState, useEffect, useRef } from "react";
import { Box, Typography, makeStyles, Slider, styled } from "@material-ui/core";

import Drawer from "./Drawer";

export default function RangeInput({ currentRefinement, min, max, refine, title, unit }) {
  const classes = useStyles();
  const [currentMin, setMin] = useState(currentRefinement?.min || min);
  const [currentMax, setMax] = useState(currentRefinement?.max || max);
  const [isEditing, setIsEditing] = useState(false);
  const debouncedSetStateRef = useRef(null);

  useEffect(() => {
    if (min && !currentMin) {
      setMin(min);
    }
    if (max && !currentMax) {
      setMax(max);
    }

    // Add debounce behaviour to reset ranges when current refinement is overriden
    clearTimeout(debouncedSetStateRef.current);
    debouncedSetStateRef.current = setTimeout(() => {
      if (!isEditing && currentRefinement.min === min && currentMin && currentMin != currentRefinement.min) {
        setMin(min);
      }
      if (!isEditing && currentRefinement.max === max && currentMax && currentMax != currentRefinement.max) {
        setMax(max);
      }
    }, 400);
  }, [min, max, currentMin, currentMax, currentRefinement, isEditing]);

  return (
    currentMin !== undefined && (
      <Drawer title={title} rangeMinValue={currentMin} rangeMaxValue={currentMax} unit={unit}>
        <Box pt={2} pb={3} pr={2} className={classes.container}>
          <CustomSlider
            getAriaLabel={() => title}
            max={currentMax > max ? currentMax : max}
            min={currentMin < min ? currentMin : min}
            value={[currentMin, currentMax]}
            onChange={(event, value) => {
              setIsEditing(true);
              setMin(value[0]);
              setMax(value[1]);
            }}
            onChangeCommitted={(event, value) => {
              refine({
                ...currentRefinement,
                min: value[0] <= min ? min : value[0],
                max: value[1] >= max ? max : value[1],
              });
              setIsEditing(false);
            }}
            color="secondary"
            valueLabelDisplay="off"
          />

          <Box justifyContent={"space-between"} display={"flex"}>
            <Typography variant="caption" className={classes.sliderText}>
              {`${currentMin} ${unit}`}
            </Typography>
            <Typography variant="caption" className={classes.sliderText}>
              {`${currentMax} ${unit}`}
            </Typography>
          </Box>
        </Box>
      </Drawer>
    )
  );
}

const CustomSlider = styled(Slider)(() => ({
  height: 2,
  "& .MuiSlider-valueLabel": {
    display: "none",
  },
}));

const useStyles = makeStyles((theme) => ({
  container: {
    padding: "16px",
  },
  input: {
    padding: 12,
    fontSize: 16,
    color: theme.palette.secondary.dark,
    fontFamily: theme.typography.fontFamily,
    borderRadius: 5,
    border: "1px solid #D7D7D7",
    width: 80,
  },
  inputTitle: {
    fontSize: 16,
  },
  title: {
    color: theme.palette.text.secondary,
    fontWeight: "bold",
    fontSize: 17,
  },
  button: {
    fontWeight: "bold",
    fontSize: 17,
    paddingBottom: 2,
    paddingRight: 0,
  },

  sliderText: {
    color: "#787878",
  },
}));
